export default {
	Auth: {
		mandatorySignIn: true,
		identityPoolId: 'eu-west-1:d9a40c8d-547f-48dd-b3c9-d9be212bed72',
		region: 'eu-west-1',
		userPoolId: 'eu-west-1_3m3bDxIfW',
		'userPoolWebClientId': '49ns4pdp4golauokovipboo9ft'
	},
	API: {
		endpoints: [
			{
				name: 'imageAPI',
				endpoint: 'https://lqj9qx4cf4.execute-api.eu-west-1.amazonaws.com/production/images/',
				region: 'eu-west-1'
			}
		]
	}
}


// WEBPACK FOOTER //
// ./src/aws-config.js